import { lazy } from 'react';

const HeaderQuickActionRoutes = [
  {
    path: 'storefront/header-quick-actions',
    component: lazy(() => import('views/storefront/header-quick-actions')),
  },
  {
    path: 'storefront/header-quick-actions/add',
    component: lazy(() => import('views/storefront/header-quick-actions/action-add')),
  },
  {
    path: 'storefront/header-quick-actions/:id',
    component: lazy(() => import('views/storefront/header-quick-actions/action-edit')),
  },
];

export default HeaderQuickActionRoutes;
